gameDiv = document.getElementById('game');
audioDiv = document.getElementById('audioDiv');
startButton = document.getElementById('start');
textDiv = document.getElementById('textDiv');
evaluateButton = document.getElementById('evaluate');



function run(texts) {
    console.log('run');

    id = getId();
    console.log('id', id)

    gameDiv.style.display = 'block';
    evaluateButton.style.display = 'block';
    startButton.style.display = 'none';
    
    loadTextsFromJson(id);
}

function getId() {
    var url = window.location.href;
    var id = url.split('?')[1].split('=')[1];
    console.log(id)
    return id;
}

function addAudioPlayer(audiofile) {
    
    if (audiofile.includes('iframe')) {
        console.log('iframe found')
        audioDiv.innerHTML = audiofile;
        return    
    }
    
    audioPlayer = document.createElement('audio');
    audioPlayer.setAttribute('controls', '');

    filepath = `./assets/${audiofile}`
    console.log('creating audioplayer for', filepath)
    audioPlayer.setAttribute('src', filepath);
    audioDiv.appendChild(audioPlayer);
}

function addTextField(text) {
    
    textField = document.createElement('textarea');
    textField.setAttribute('id', 'textField');
    textField.placeholder = 'Tippe hier ein, was du hörst.';
    textField.input = "evaluateInput()";
    textDiv.appendChild(textField);
}